import { useGetRollCallForEvent } from 'api/Event/Attendance'
import Spinner from 'components/Spinner'
import { convertToLocal, getUserName } from 'helper/utility'
import React, { useEffect, useState } from 'react'
import { AttendeeStatusParams, RollCallResp } from 'types/event/eventAttendance'
import Roolimg from 'assets/Images/lookout.svg'
import { Checkbox } from 'antd'
import GetAvatar from 'components/global/GetAvatar'
import { CheckboxChangeEvent } from 'antd/lib/checkbox'
import { eventAttendanceStore } from 'state/event/eventAttendance'

interface RollCallsProps {
  params: AttendeeStatusParams
}

const RollCalls: React.FC<RollCallsProps> = ({ params }) => {
  const { setRollCallModalOpen, setRollCallData, setCheckInOutModalOpen } =
    eventAttendanceStore(store => ({
      setRollCallModalOpen: store.setRollCallModalOpen,
      setRollCallData: store.setRollCallData,
      setCheckInOutModalOpen: store.setCheckInOutModalOpen,
    }))
  const [isAttendeesVisible, setShowAttendees] = useState<number | null>(null)
  const { data, isLoading, isFetching, refetch } =
    useGetRollCallForEvent(params)

  const handleEditClick = (rollCall: RollCallResp) => {
    setRollCallData(rollCall)
    setCheckInOutModalOpen(false)
    setRollCallModalOpen(true)
  }

  useEffect(() => {
    refetch()
  }, [params])

  return (
    <div>
      {isLoading || isFetching ? (
        <div className="py-40px flex justify-center">
          <Spinner />
        </div>
      ) : (
        <>
          {data.length ? (
            data?.map((list, index) => {
              const dateObj = convertToLocal(list.time, 'hh:mm A')
              const defaultChecked = list.participants?.map(
                part => part._id,
              ) || ['']

              return (
                <div className=" mt-20px border-btm  pb-10px">
                  <div className="flex-center">
                    <img src={Roolimg} alt="Rool Call" />
                    <div className="ml-20px flex-center justify-between w-full">
                      <div>
                        <h2 className="text-16">
                          {list.name} .{' ' + dateObj}
                        </h2>
                        <h4></h4>
                      </div>
                      {list?.participants && list?.participants?.length > 0 && (
                        <h2
                          className="text-18 prim-txt pointer"
                          onClick={() => {
                            setShowAttendees(
                              isAttendeesVisible === index ? null : index,
                            )
                          }}
                        >
                          {isAttendeesVisible === index ? 'Close' : 'Open'}
                        </h2>
                      )}
                    </div>
                  </div>
                  {isAttendeesVisible === index && (
                    <>
                      <div className="ml-20px">
                        <Checkbox.Group
                          options={list.participants?.map(atendee => ({
                            label: (
                              <div className="flex-center ml-10px">
                                <GetAvatar person={atendee} />
                                <h2 className="text-16 ml-10">
                                  {getUserName(atendee)}
                                </h2>
                              </div>
                            ),

                            value: atendee._id,
                            disabled: true,
                          }))}
                          className="mt-20px atendeeCheckbox"
                          defaultValue={defaultChecked}
                        />
                      </div>
                      <div className="flex justify-end">
                        <button
                          className="mt-20px button bg-blue text-white"
                          onClick={() => handleEditClick(list)}
                        >
                          Edit Roll-call
                        </button>
                      </div>
                    </>
                  )}
                </div>
              )
            })
          ) : (
            <h3>No roll-calls found</h3>
          )}
        </>
      )}
    </div>
  )
}

export default RollCalls
